import { Color } from '@shared/enums';

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'color',
  standalone: true,
})
export class ColorPipe implements PipeTransform {
  transform(value: keyof typeof Color, def: keyof typeof Color = 'CREAM'): string {
    return Color[value] || def;
  }
}
